ht.setSessionHeader = function (xhr, opts) {
  xhr.setRequestHeader('X-xsesschk', ht.getSessionToken());
};
